import { Modal } from "antd";
import { ModalProps } from "./Modal";

function CommonModal({
  open,
  closable,
  onCancel,
  width,
  Children,
}: ModalProps) {
  return (
    <>
      <Modal
        open={open}
        closable={closable}
        onCancel={onCancel}
        width={width}
        footer={null}
      >
        {Children}
      </Modal>
    </>
  );
}

export default CommonModal;
